module.exports = __webpack_public_path__ + "media/images/emblems/Chavannes-des-Bois-coat_of_arms-52708f23860eb3058cdeaa83274a9749.svg";